'use client'

import { setCookie } from 'cookies-next'
import { ChevronRight } from 'lucide-react'
import Image from 'next/image'
import { usePathname } from 'next/navigation'
import { useState } from 'react'

interface PrivacyInlineMessageClientProps {
  initialDismissed: boolean
}

export function PrivacyInlineMessageClient({
  initialDismissed,
}: PrivacyInlineMessageClientProps) {
  const [isDismissed, setIsDismissed] = useState(initialDismissed)
  const pathname = usePathname()

  // Don't show on login, auth, or offboarding pages
  const shouldHideForPath =
    pathname.startsWith('/login') ||
    pathname.startsWith('/auth') ||
    pathname.startsWith('/offboarding')

  const handleDismiss = () => {
    // Set cookie with 30-day expiration
    setCookie('polaris-privacy-announcement-dismissed', 'true', {
      maxAge: 30 * 24 * 60 * 60, // 30 days in seconds
    })
    setIsDismissed(true)
  }

  const handleSignUp = () => {
    window.open('https://tally.so/r/w4eXbO', '_blank', 'noopener,noreferrer')
    handleDismiss()
  }

  // Hide if should hide for path or if dismissed
  if (shouldHideForPath || isDismissed) {
    return null
  }

  return (
    <div className='w-full flex justify-center'>
      <div className='flex flex-col sm:flex-row sm:items-center sm:justify-between w-full max-w-4xl p-4 rounded-[20px] border border-border2 min-h-[24px] gap-4'>
        {/* Avatar + Text Row */}
        <div className='flex items-center gap-4 w-full sm:flex-1 sm:min-w-0'>
          <Image
            src='https://s3.polaris.app/avatars/avatar.png'
            alt='Privacy announcement'
            width={32}
            height={32}
            className='rounded-full flex-shrink-0 size-8'
          />
          <div className='flex-1 w-full flex items-center'>
            <span className='text-primary font-normal text-sm w-full'>
              Private trading, coming soon to Polaris. Want early access?
            </span>
          </div>
        </div>

        {/* Actions */}
        <div className='flex items-center justify-center sm:justify-end flex-shrink-0 gap-4'>
          <button
            onClick={handleDismiss}
            className='text-link text-sm font-medium transition-colors whitespace-nowrap'
          >
            No, thanks
          </button>
          <div
            onClick={handleSignUp}
            className='text-link text-sm font-medium transition-colors flex items-center gap-1 whitespace-nowrap cursor-pointer'
          >
            Sign me up
            <ChevronRight size={24} />
          </div>
        </div>
      </div>
    </div>
  )
}
